import { render, staticRenderFns } from "./TrafficBasedApp.vue?vue&type=template&id=3de1e830&"
import script from "./TrafficBasedApp.vue?vue&type=script&lang=js&"
export * from "./TrafficBasedApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports